<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> List Holiday
        </span>
        <a-input
          placeholder="Search..."
          style="width: 350px; max-width: 100%; margin-right: 5px;"
          @change="onFilter"
          v-model="filter.query"
        />
        <a-select
          placeholder="Select year"
          v-model="filter.year"
          style="width: 200px; margin-right: 5px;"
          @change="onFilter"
          allowClear
        >
          <a-select-option v-for="item in listYears" :key="item">
            {{ item }}
          </a-select-option>
        </a-select>
        <!-- <a-button-group style="margin-right: 5px;">
          <a-button
            @click="onChangeStatusFilter()"
            :type="!filter.status ? 'primary' : ''"
            >Tất cả
          </a-button>
          <a-button
            @click="onChangeStatusFilter('ACTIVE')"
            :type="filter.status === 'ACTIVE' ? 'primary' : ''"
          >
            Đang hoạt động
          </a-button>
          <a-button
            @click="onChangeStatusFilter('DEACTIVE')"
            :type="filter.status === 'DEACTIVE' ? 'primary' : ''"
          >
            Ngừng hoạt động
          </a-button>
        </a-button-group> -->
        <a-button
          slot="extra"
          type="primary"
          @click="() => (visibleAdd = true)"
        >
          <a-icon type="plus" /> Add New
        </a-button>
      </div>

      <a-table
        :columns="columnsAllHoliday"
        :data-source="holidays"
        size="small"
        :loading="loadingList"
        rowKey="id"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <div slot="footer">
          <a-button
            :loading="loadingList"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>
        <div slot="name" slot-scope="text, record">
          <a @click="collapseVisibleEdit(record.id)"> {{ text }} </a>
        </div>

        <span slot="startDate" slot-scope="text">
          {{ text | formatDate }}
        </span>
        <span slot="endDate" slot-scope="text">
          {{ text | formatDate }}
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="updatedAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="action" style="float: right;" slot-scope="text, record">
          <a-button @click="collapseVisibleEdit(record.id)">
            <a-icon title="Chỉnh sửa" type="edit" /> Edit
          </a-button>
        </span>
      </a-table>

      <a-drawer
        v-if="visibleEdit"
        title="Edit"
        placement="right"
        :visible="visibleEdit"
        @close="() => (visibleEdit = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <EditHoliday
          :idHoliday="idHoliday"
          :close="() => (visibleEdit = false)"
          :refreshAfterUpdated="refreshAfterUpdated"
          :refreshAfterDeleted="refreshAfterDeleted"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleAdd"
        title="Add New"
        placement="right"
        :visible="visibleAdd"
        @close="() => (visibleAdd = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <AddHoliday
          :close="() => (visibleAdd = false)"
          :refreshAfterCreated="refreshAfterCreated"
        />
      </a-drawer>
    </a-card>
  </div>
</template>
<script>
import { columnsAllHoliday } from "./constant/column";
import AddHoliday from "./components/addHoliday";
import EditHoliday from "./components/editHoliday";
import query from "./constant/query";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";
import debounce from "lodash/debounce";
const limit = 10;
const startPage = 1;
const nowYear = new Date().getFullYear();
const defaultFilter = { query: "", year: +nowYear };
function range(start, end) {
  var ans = [];

  for (let i = start; i <= end; i++) {
    ans.push(i);
  }
  return ans;
}

const listYears = range(+nowYear - 5, +nowYear + 5);
export default {
  components: {
    AddHoliday,
    EditHoliday,
  },
  data() {
    this.onFilter = debounce(this.onFilter, 500);
    return {
      listYears,
      limit,
      visibleEdit: false,
      visibleDetail: false,
      visibleAdd: false,
      columnsAllHoliday,
      loadingList: true,
      holidays: [],
      idHoliday: "",
      filter: defaultFilter,
      currentPage: startPage,
      totalPage: startPage,
      isPagination: true,
    };
  },
  methods: {
    onGetAllHoliday(flag) {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getListHoliday,
          fetchPolicy: "no-cache",
          variables: {
            limit,
            query: this.filter.query,
            page: this.totalPage,
            status: this.filter.status,
            year: this.filter.year,
          },
        })
        .then(({ data }) => {
          this.loadingList = false;
          if (data?.getListHoliday?.length >= 0) {
            if (flag === "FILTER") {
              this.holidays = [...data.getListHoliday];
            } else if (flag === "PAGINATION") {
              this.holidays = this.holidays.concat([...data.getListHoliday]);
            } else {
              this.holidays = [...data.getListHoliday];
            }
            // check is pagniation
            if (data.getListHoliday.length < limit) {
              this.isPagination = false;
            } else {
              this.isPagination = true;
            }
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Get Item Error!",
          });
          console.log("Lấy danh sách ngày nghỉ lễ không thành công", err);
        });
    },
    collapseVisibleDetail(id) {
      if (id) {
        this.idHoliday = id;
        this.visibleDetail = true;
      } else {
        this.idHoliday = "";
        this.visibleDetail = false;
      }
    },
    collapseVisibleEdit(id) {
      if (id) {
        this.idHoliday = id;
        this.visibleEdit = true;
      } else {
        this.idHoliday = "";
        this.visibleEdit = false;
      }
    },
    onFilter() {
      this.currentPage = startPage;
      this.totalPage = startPage;
      this.onGetAllHoliday("FILTER");
    },
    refreshAfterUpdated(item) {
      this.holidays = updateForUpdated(this.holidays, item);
    },
    refreshAfterDeleted(item) {
      this.holidays = updateForDeleted(this.holidays, item);
    },
    refreshAfterCreated(item) {
      this.holidays = updateForCreated({
        list: this.holidays,
        item,
        limit,
        currentPage: this.currentPage,
      });
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.onGetAllHoliday("PAGINATION");
      }
    },
    onChangeStatusFilter(status) {
      this.$set(this.filter, "status", status || undefined);
      this.onFilter();
    },
  },
  created() {
    this.onGetAllHoliday();
  },
};
</script>
<style lang="css" scoped></style>
